import * as yup from "yup";

// export const SiteInspectionSchema = yup.object().shape({
//   projectId: yup.number(),
//   inspectionDate: yup.date(),
//   tentativeStartDate: yup.date(),
//   generatedBy: yup.string(),
//   siteAddress: yup.string().required("Required"),
//   sitePinCode: yup.string().required("Required"),
//   siteManagerName: yup.string(),
//   siteManagerPhone: yup.string(),
//   quotationNumber: yup.string(),
//   aifQuotationNumber: yup.string(),
//   numberOfStaff: yup.number(),
//   typeOfSite: yup
//     .string()
//     .oneOf(
//       [
//         "farmLand",
//         "naPlot",
//         "indoor",
//         "underConstructionSite",
//         "commercialSite",
//         "governmentPlot",

//         null,
//       ],
//       "invalid type"
//     ),
//   soilType: yup
//     .string()
//     .oneOf(
//       [
//         "blackSoil",
//         "redSoil",
//         "dusty",
//         "concrete",
//         "sand",
//         "vertisol",
//         "stoned",
//         "hardToFind",

//         null,
//       ],
//       "invalid type"
//     ),
//   totalAvailableAreaUnit: yup
//     .string()
//     .oneOf(
//       [
//         "acre",
//         "hectare",
//         "guntha",
//         "cent",
//         "sqft",
//         "sqmt",
//         "yard",
//         "bigha",
//         null,
//       ],
//       "Invalid type"
//     ),
//   totalAvailableAreaNumber: yup.number(),
//   landOwnership: yup
//     .string()
//     .oneOf(
//       [
//         "own",
//         "rent",
//         "leased",
//         "partnership",
//         "planning to purchase",
//         "planning to lease",
//       ],
//       "Invalid type"
//     ),

//   landLeveling: yup
//     .string()
//     .oneOf(["required", "alreadyDone", "hardToFindOut"], "Invalid type"),

//   naturalSlopeOfLand: yup
//     .string()
//     .oneOf(
//       [
//         "north",
//         "south",
//         "east",
//         "west",
//         "northEast",
//         "northWest",
//         "southEast",
//         "southWest",
//         "unclear",
//         "hardToFind",

//         null,
//       ],
//       "invalid type"
//     ),
//   //land
//   landHasTree: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   landHasStones: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   landHasPond: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   landHasMudPatch: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   landHasHillock: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   landFencingType: yup
//     .string()
//     .oneOf(
//       [
//         "noFencing",
//         "stoned",
//         "cementPoll",
//         "cementWall",
//         "preFab",
//         "wired",
//         "makeShift",
//         null,
//       ],
//       "Invalid type"
//     ),

//   landFencingHeightInFeet: yup.number(),
//   whatsOnNorth: yup
//     .string()
//     .oneOf(
//       [
//         "ownLand",
//         "landBelongsToSomeoneElse",
//         "waterBody",
//         "road",
//         "fencing",
//         "wall",
//         "slopeLand",
//         "disputedLand",
//         "governmentLand",

//         "other",
//         null,
//       ],
//       "invalid type"
//     ),
//   whatsOnEast: yup
//     .string()
//     .oneOf(
//       [
//         "ownLand",
//         "landBelongsToSomeoneElse",
//         "waterBody",
//         "road",
//         "fencing",
//         "wall",
//         "slopeLand",
//         "disputedLand",
//         "governmentLand",
//         "other",

//         null,
//       ],
//       "invalid type"
//     ),
//   whatsOnSouth: yup
//     .string()
//     .oneOf(
//       [
//         "ownLand",
//         "landBelongsToSomeoneElse",
//         "waterBody",
//         "road",
//         "fencing",
//         "wall",
//         "slopeLand",
//         "disputedLand",
//         "governmentLand",
//         "other",

//         null,
//       ],
//       "invalid type"
//     ),
//   whatsOnWest: yup
//     .string()
//     .oneOf(
//       [
//         "ownLand",
//         "landBelongsToSomeoneElse",
//         "waterBody",
//         "road",
//         "fencing",
//         "wall",
//         "slopeLand",
//         "disputedLand",
//         "governmentLand",
//         "other",

//         null,
//       ],
//       "invalid type"
//     ),
//   obstaclesTowardsSky: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   //photoFunction
//   obstaclesTowardsSkyPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   googleMapsLocationLink: yup.string().required("Required"),

//   // water
//   waterSourceType: yup
//     .string()
//     .oneOf(
//       [
//         "borewell",
//         "well",
//         "municipalWater",
//         "pond",
//         "rainHarvesting",
//         "tanker",

//         null,
//       ],
//       "invalid type"
//     ),
//   waterTankCapacityInLitre: yup.string(),
//   waterAvailabilityFrequency: yup
//     .string()
//     .oneOf(
//       [
//         "uninterrupted",
//         "onDemand",
//         "onAvailabilityOfElectricity",
//         "onceAday",
//         "onceAweek",
//         "onceAmonth",

//         null,
//       ],
//       "invalid type"
//     ),
//   positionOfWaterTank: yup
//     .string()
//     .oneOf(
//       [
//         "north",
//         "south",
//         "east",
//         "west",
//         "northEast",
//         "northWest",
//         "southEast",
//         "southWest",
//         "unclear",

//         null,
//       ],
//       "invalid type"
//     ),
//   //photoFunction
//   waterTankLocationPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   waterPhReading: yup.string(),
//   waterEcReading: yup.string(),
//   //photoFunction
//   waterReportPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),

//   // sunlight
//   entryToFarmSite: yup
//     .string()
//     .oneOf(
//       [
//         "north",
//         "south",
//         "east",
//         "west",
//         "northEast",
//         "northWest",
//         "southEast",
//         "southWest",
//         "unclear",

//         null,
//       ],
//       "invalid type"
//     ),
//   //photoFunction
//   entryTofarmPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),

//   luxReading: yup.string(),
//   luxReadingPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   luxDeffusionSheet: yup.string(),
//   luxDeffusionSheetPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   luxWovenPoly: yup.string(),
//   luxWovenPolyPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   luxUvOpen: yup.string(),
//   luxUvOpenPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),

//   // climate
//   temperatureReading: yup.string(),
//   temperatureReadingPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   humidityReading: yup.string(),
//   humidityReadingPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   climateHottestMonth: yup
//     .string()
//     .oneOf(
//       [
//         "january",
//         "february",
//         "march",
//         "april",
//         "may",
//         "june",
//         "july",
//         "august",
//         "september",
//         "october",
//         "november",
//         "december",

//         null,
//       ],
//       "invalid type"
//     ),
//   climateColdestMonth: yup
//     .string()
//     .oneOf(
//       [
//         "january",
//         "february",
//         "march",
//         "april",
//         "may",
//         "june",
//         "july",
//         "august",
//         "september",
//         "october",
//         "november",
//         "december",
//         null,
//       ],
//       "invalid type"
//     ),

//   // dimensions
//   northSouthMeasurmentInMeter: yup.string(),
//   northSouthMeasurmentPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   eastWestMeasurmentInMeter: yup.string(),
//   eastWestMeasurmentPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   layoutPhoto: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),

//   // Facilities
//   facilityToStoreItems: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   facilityToStay: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   facilityHasBathroom: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   facilityHasDrinkingWater: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   facilityHasKitchenSpace: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   facilityHasFuelForCooking: yup
//     .boolean()

//     .oneOf([true, false], "Invalid type"),
//   transportOption: yup.string().oneOf(["byRoad", "byWater"], "Invalid type"),

//   nearestTarRoad: yup
//     .string()
//     .oneOf(
//       [
//         "0km To 1km",
//         "1km To 3km",
//         "3km To 5km",
//         "5km To 20km",
//         "20km To 50km",
//         null,
//       ],
//       "Invalid type"
//     ),

//   nearestMarket: yup
//     .string()
//     .oneOf(
//       [
//         "0km To 1km",
//         "1km To 3km",
//         "3km To 5km",
//         "5km To 20km",
//         "20km To 50km",
//         null,
//       ],
//       "Invalid type"
//     ),

//   nearestMedicalFacility: yup
//     .string()
//     .oneOf(
//       [
//         "0km To 1km",
//         "1km To 3km",
//         "3km To 5km",
//         "5km To 20km",
//         "20km To 50km",
//         null,
//       ],
//       "Invalid type"
//     ),

//   nearestStayFacility: yup
//     .string()
//     .oneOf(
//       [
//         "0km To 1km",
//         "1km To 3km",
//         "3km To 5km",
//         "5km To 20km",
//         "20km To 50km",
//         null,
//       ],
//       "Invalid type"
//     ),

//   nearestBusStand: yup.string(),
//   nearestRailwayStation: yup.string(),
//   nearestAirport: yup.string(),
//   nearestTier1City: yup.string(),
//   nearestTier1CityDistance: yup.number(),
//   nearestTier2City: yup.string(),
//   nearestTier2CityDistance: yup.number(),
//   regulerModeOfTransportation: yup
//     .string()
//     .oneOf(
//       ["ownVehicle", "privateVehicle", "governmentVehicle", "train", null],
//       "Invalid type"
//     ),

//   vehicleAvilableForEmergency: yup
//     .string()
//     .oneOf(
//       ["unavailable", "2 wheeler", "3 wheeler", "4 wheeler"],
//       "Invalid type"
//     ),

//   electricityConnectionAvailable: yup
//     .boolean()
//     .oneOf([true, false], "Invalid type"),
//   electricityMeterType: yup
//     .string()
//     .oneOf(
//       [
//         "residential",
//         "commercial",
//         "agricultural",
//         "solar",
//         "industrial",
//         "freeUse",

//         null,
//       ],
//       "invalid type"
//     ),
//   electricityMeterPhaseType: yup
//     .string()
//     .oneOf(["singlePhase", "threePhase", "both"], "Invalid type"),

//   electricityOutageFrequency: yup
//     .string()
//     .oneOf(
//       [
//         "never",
//         "sometimes",
//         "occasionally",
//         "lowFrequency",
//         "highFrequency",
//         null,
//       ],
//       "Invalid type"
//     ),
//   electricityUnitPrice: yup.number(),
//   electricityPricingModel: yup
//     .string()
//     .oneOf(["uniform", "bracketed", "subsidised"], "Invalid type"),

//   electricityUsage: yup
//     .string()
//     .oneOf(
//       [
//         "hydroponicsOnly",
//         "sharedWithFactory",
//         "sharedWithHome",
//         "sharedWithFarming",

//         null,
//       ],
//       "invalid type"
//     ),
//   internetConnectivity: yup
//     .string()
//     .oneOf(["noInternet", "broadband", "portableHotspot"], "Invalid type"),

//   descriptionVideo: yup.mixed().test(
//     "is-valid-size",
//     "Max allowed size is 10MB",
//     (value) => {
//       if (value && value.size) {
//         return value.size <= 10 * 1024 * 1024;
//       } else {
//         return true;
//       }
//     } // Ensure value exists and size is valid
//   ),
//   notes: yup.string(),
//   salesRelationshipManager: yup.string().required("Required"),
//   lookingForGovernmentSupport: yup.boolean(),
//   projectOwnerGender: yup.string(),
//   location: yup.string(),
//   cast: yup.string(),
//   averageLabourSalary: yup.number(),
//   monthlyLeasedAmount: yup.number(),
//   projectFundingPlan: yup.string(),
//   futureExpectationFromPlan: yup.string(),
//   experienceWithFarming: yup.string(),
//   currentProfession: yup.string(),
//   markSiteNotFeasible: yup.boolean(),
//   markWaterNotAvailable: yup.boolean(),
//   lookingForLoan: yup.boolean(),
//   loanBanks: yup.string(),
//   reasonOfNonFeasibility: yup.string().when("markSiteNotFeasible", {
//     is: (val) => val,
//     then: (s) => yup.string().required("Required"),
//   }),
//   appliedForAIFDPR: yup.boolean(),
//   borrowFromBank: yup.number().when("appliedForAIFDPR", {
//     is: (val) => val,
//     then: (s) => yup.number().required("Required"),
//   }),
//   tenure: yup.number().when("appliedForAIFDPR", {
//     is: (val) => val,
//     then: (s) => yup.number().required("Required"),
//   }),
//   rateOfInt: yup.number().when("appliedForAIFDPR", {
//     is: (val) => val,
//     then: (s) => yup.number().required("Required"),
//   }),
//   fundingAmmountType: yup.string().when("appliedForAIFDPR", {
//     is: (val) => val,
//     then: (s) => yup.string().required("Required"),
//   }),
// });
export const SiteInspectionSchema = [
  // Promoter details
  yup.object({
    projectId: yup.number(),
    inspectionDate: yup.date(),
    generatedBy: yup.string(),
    name: yup.string(),
    dateOfBirth: yup.date(),
    currentProfession: yup.string(),
    highestQualification: yup.string(),
    experienceWithFarming: yup.string(),
    cast: yup.string(),
    projectOwnerGender: yup
      .string()
      .oneOf(["male", "female", null], "Invalid role value"),
  }),
  // site details
  yup.object({
    applicationType: yup.string(),
    siteAddressLine1: yup.string(),
    siteAddressLine2: yup.string(),
    city: yup.string(),
    state: yup.string(),
    sitePinCode: yup.string(),
    identitfyLocation: yup.string(),
    locationIdentification: yup.string(),
    typeOfSite: yup
      .string()
      .oneOf(
        [
          "farmLand",
          "naPlot",
          "indoor",
          "underConstructionSite",
          "commercialSite",
          "governmentPlot",

          null,
        ],
        "invalid type"
      ),
    latitudeAndLongitude: yup.string(),
  }),
  // management details
  yup.object({
    tentativeStartDate: yup.date(),
    siteManagerAppointed: yup.string(),
    siteManagerName: yup.string(),
    siteManagerPhone: yup.string(),
    numberOfStaff: yup.number(),
  }),

  // Land details
  yup.object({
    soilType: yup
      .string()
      .oneOf(
        [
          "blackSoil",
          "redSoil",
          "dusty",
          "concrete",
          "sand",
          "vertisol",
          "stoned",
          "hardToFind",

          null,
        ],
        "invalid type"
      ),
    totalAvailableAreaNumber: yup.string(),
    totalAvailableAreaUnit: yup
      .string()
      .oneOf(
        [
          "acre",
          "hectare",
          "guntha",
          "cent",
          "sqft",
          "sqmt",
          "yard",
          "bigha",
          null,
        ],
        "Invalid type"
      ),
    landLeveling: yup
      .string()
      .oneOf(["required", "alreadyDone", "hardToFindOut"], "Invalid type"),
    naturalSlopeOfLand: yup
      .string()
      .oneOf(
        [
          "north",
          "south",
          "east",
          "west",
          "northEast",
          "northWest",
          "southEast",
          "southWest",
          "unclear",
          "hardToFind",

          null,
        ],
        "invalid type"
      ),

    landOwnership: yup
      .string()
      .oneOf(
        [
          "own",
          "rent",
          "leased",
          "partnership",
          "planning to purchase",
          "planning to lease",
        ],
        "Invalid type"
      ),
    landHasTree: yup.boolean().oneOf([true, false], "Invalid type"),
    landHasStones: yup.boolean().oneOf([true, false], "Invalid type"),
    landHasPond: yup.boolean().oneOf([true, false], "Invalid type"),
    landHasMudPatch: yup.boolean().oneOf([true, false], "Invalid type"),
    landHasHillock: yup.boolean().oneOf([true, false], "Invalid type"),
  }),
  // Dimenstion Details
  yup.object({
    whatsOnNorth: yup
      .string()
      .oneOf(
        [
          "ownLand",
          "landBelongsToSomeoneElse",
          "waterBody",
          "road",
          "fencing",
          "wall",
          "slopeLand",
          "disputedLand",
          "governmentLand",

          "other",
          null,
        ],
        "invalid type"
      ),
    whatsOnEast: yup
      .string()
      .oneOf(
        [
          "ownLand",
          "landBelongsToSomeoneElse",
          "waterBody",
          "road",
          "fencing",
          "wall",
          "slopeLand",
          "disputedLand",
          "governmentLand",
          "other",

          null,
        ],
        "invalid type"
      ),
    whatsOnSouth: yup
      .string()
      .oneOf(
        [
          "ownLand",
          "landBelongsToSomeoneElse",
          "waterBody",
          "road",
          "fencing",
          "wall",
          "slopeLand",
          "disputedLand",
          "governmentLand",
          "other",

          null,
        ],
        "invalid type"
      ),
    whatsOnWest: yup
      .string()
      .oneOf(
        [
          "ownLand",
          "landBelongsToSomeoneElse",
          "waterBody",
          "road",
          "fencing",
          "wall",
          "slopeLand",
          "disputedLand",
          "governmentLand",
          "other",

          null,
        ],
        "invalid type"
      ),

    obstaclesTowardsSky: yup.boolean().oneOf([true, false], "Invalid type"),
    //photoFunction
    obstaclesTowardsSkyPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    googleMapsLocationLink: yup.string(),
    landFencingType: yup
      .string()
      .oneOf(
        [
          "noFencing",
          "stoned",
          "cementPoll",
          "cementWall",
          "preFab",
          "wired",
          "makeShift",
          null,
        ],
        "Invalid type"
      ),
    landFencingHeightInFeet: yup.number(),
    northSouthMeasurmentInMeter: yup.string(),
    northSouthMeasurmentPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    eastWestMeasurmentInMeter: yup.string(),
    eastWestMeasurmentPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    layoutPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    costructionLayout: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    systemLayout: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    pEndView: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    PCenterView: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    PSideView: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
  }),

  // Mesurment Details

  yup.object({
    northSouthMeasurmentInMeter: yup.string(),
    northSouthMeasurmentPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    northSouthMeasurmentViedo: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    eastWestMeasurmentInMeter: yup.string(),
    eastWestMeasurmentPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    eastWestMeasurmentViedo: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
  }),
  //  Water Details
  yup.object({
    waterSourceType: yup
      .string()
      .oneOf(
        [
          "borewell",
          "well",
          "municipalWater",
          "pond",
          "rainHarvesting",
          "tanker",

          null,
        ],
        "invalid type"
      ),
    waterTankCapacityInLitre: yup.string(),
    waterAvailabilityFrequency: yup
      .string()
      .oneOf(
        [
          "uninterrupted",
          "onDemand",
          "onAvailabilityOfElectricity",
          "onceAday",
          "onceAweek",
          "onceAmonth",

          null,
        ],
        "invalid type"
      ),
    positionOfWaterTank: yup
      .string()
      .oneOf(
        [
          "north",
          "south",
          "east",
          "west",
          "northEast",
          "northWest",
          "southEast",
          "southWest",
          "unclear",

          null,
        ],
        "invalid type"
      ),
    //photoFunction
    waterTankLocationPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),

    waterPhReading: yup.string(),
    waterEcReading: yup.string(),
    //photoFunction
    waterReportPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
  }),
  //  Sunlight Details
  yup.object({
    entryToFarmSite: yup
      .string()
      .oneOf(
        [
          "north",
          "south",
          "east",
          "west",
          "northEast",
          "northWest",
          "southEast",
          "southWest",
          "unclear",

          null,
        ],
        "invalid type"
      ),
    //photoFunction
    entryTofarmPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),

    luxReading: yup.string(),
    luxReadingPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    luxDeffusionSheet: yup.string(),
    luxDeffusionSheetPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    luxWovenPoly: yup.string(),
    luxWovenPolyPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    luxUvOpen: yup.string(),
    luxUvOpenPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
  }),
  // Climate Details
  yup.object({
    temperatureReading: yup.string(),
    temperatureReadingPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    humidityReading: yup.string(),
    humidityReadingPhoto: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    climateHottestMonth: yup
      .string()
      .oneOf(
        [
          "january",
          "february",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",

          null,
        ],
        "invalid type"
      ),
    climateColdestMonth: yup
      .string()
      .oneOf(
        [
          "january",
          "february",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",
          null,
        ],
        "invalid type"
      ),
  }),
  // faciliteis
  yup.object({
    facilityToStoreItems: yup
      .boolean()

      .oneOf([true, false], "Invalid type"),
    facilityToStay: yup
      .boolean()

      .oneOf([true, false], "Invalid type"),
    facilityHasBathroom: yup
      .boolean()

      .oneOf([true, false], "Invalid type"),
    facilityHasDrinkingWater: yup
      .boolean()

      .oneOf([true, false], "Invalid type"),
    facilityHasKitchenSpace: yup
      .boolean()

      .oneOf([true, false], "Invalid type"),
    facilityHasFuelForCooking: yup
      .boolean()
      .oneOf([true, false], "Invalid type"),
  }),
  // Transport Options
  yup.object({
    transportOption: yup.string().oneOf(["byRoad", "byWater"], "Invalid type"),

    nearestTarRoad: yup
      .string()
      .oneOf(
        [
          "0km To 1km",
          "1km To 3km",
          "3km To 5km",
          "5km To 20km",
          "20km To 50km",
          null,
        ],
        "Invalid type"
      ),

    regulerModeOfTransportation: yup
      .string()
      .oneOf(
        ["ownVehicle", "privateVehicle", "governmentVehicle", "train", null],
        "Invalid type"
      ),

    vehicleAvilableForEmergency: yup
      .string()
      .oneOf(
        ["unavailable", "2 wheeler", "3 wheeler", "4 wheeler"],
        "Invalid type"
      ),
  }),
  // Nearest Faciliteis
  yup.object({
    nearestMarket: yup
      .string()
      .oneOf(
        [
          "0km To 1km",
          "1km To 3km",
          "3km To 5km",
          "5km To 20km",
          "20km To 50km",
          null,
        ],
        "Invalid type"
      ),

    nearestMedicalFacility: yup
      .string()
      .oneOf(
        [
          "0km To 1km",
          "1km To 3km",
          "3km To 5km",
          "5km To 20km",
          "20km To 50km",
          null,
        ],
        "Invalid type"
      ),

    nearestStayFacility: yup
      .string()
      .oneOf(
        [
          "0km To 1km",
          "1km To 3km",
          "3km To 5km",
          "5km To 20km",
          "20km To 50km",
          null,
        ],
        "Invalid type"
      ),
    nearestBusStand: yup.string(),
    nearestRailwayStation: yup.string(),
    nearestAirport: yup.string(),
    nearestTier1City: yup.string(),
    nearestTier1CityDistance: yup.number(),
    nearestTier2City: yup.string(),
    nearestTier2CityDistance: yup.number(),
  }),
  // Electricity Connection
  yup.object({
    electricityConnectionAvailable: yup
      .boolean()
      .oneOf([true, false], "Invalid type"),
    electricityMeterType: yup
      .string()
      .oneOf(
        [
          "residential",
          "commercial",
          "agricultural",
          "solar",
          "industrial",
          "freeUse",

          null,
        ],
        "invalid type"
      ),
    electricityMeterPhaseType: yup
      .string()
      .oneOf(["singlePhase", "threePhase", "both"], "Invalid type"),

    electricityOutageFrequency: yup
      .string()
      .oneOf(
        [
          "never",
          "sometimes",
          "occasionally",
          "lowFrequency",
          "highFrequency",
          null,
        ],
        "Invalid type"
      ),
    electricityUnitPrice: yup.number(),
    electricityPricingModel: yup
      .string()
      .oneOf(["uniform", "bracketed", "subsidised"], "Invalid type"),

    electricityUsage: yup
      .string()
      .oneOf(
        [
          "hydroponicsOnly",
          "sharedWithFactory",
          "sharedWithHome",
          "sharedWithFarming",

          null,
        ],
        "invalid type"
      ),
    internetConnectivity: yup
      .string()
      .oneOf(["noInternet", "broadband", "portableHotspot"], "Invalid type"),
  }),
  // Financial Details
  yup.object({
    quotationNumber: yup.string(),
    averageLabourSalary: yup.string(),
    monthlyLeasedAmount: yup.string(),
    projectFundingPlan: yup.string(),
    primaryLoanBank: yup.string(),
    primaryLoanIfsc: yup.string(),
    secondaryLoanBank: yup.string(),
    secondaryLoanIfsc: yup.string(),
    futureExpectationFromPlan: yup.string(),
    lookingForGovernmentSupport: yup.boolean(),
    lookingForLoan: yup.boolean(),
  }),
  // Additonal Details
  yup.object({
    descriptionVideo: yup.mixed().test(
      "is-valid-size",
      "Max allowed size is 10MB",
      (value) => {
        if (value && value.size) {
          return value.size <= 10 * 1024 * 1024;
        } else {
          return true;
        }
      } // Ensure value exists and size is valid
    ),
    notes: yup.string(),
    salesRelationshipManager: yup.string(),
  }),
  // AIF Details
  yup.object({
    appliedForAIFDPR: yup.boolean(),
    borrowFromBank: yup.number().when("appliedForAIFDPR", {
      is: (val) => val,
      then: (s) => yup.number().required("Required"),
    }),
    aifQuotationNumber: yup.string().when("appliedForAIFDPR", {
      is: (val) => val,
      then: (s) => yup.string().required("Required"),
    }),
    tenure: yup.number().when("appliedForAIFDPR", {
      is: (val) => val,
      then: (s) => yup.number().required("Required"),
    }),
    rateOfInt: yup.number().when("appliedForAIFDPR", {
      is: (val) => val,
      then: (s) => yup.number().required("Required"),
    }),
    fundingAmmountType: yup.string().when("appliedForAIFDPR", {
      is: (val) => val,
      then: (s) => yup.string().required("Required"),
    }),
  }),
];
